module.exports = __webpack_public_path__ + "static/champions-of-coaching-862f8ad6f909a2e48a5d860e2fadcd89.jpg";